import React from 'react'

import { IconProps } from './types'

const Empty = ({ size, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    width={size}
    height={size}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 34C29.5228 34 34 29.5228 34 24C34 18.4772 29.5228 14 24 14C18.4772 14 14 18.4772 14 24C14 29.5228 18.4772 34 24 34ZM24 40C32.8366 40 40 32.8366 40 24C40 15.1634 32.8366 8 24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40Z"
      fill="#D19CE2"
    />
    <path
      className="fill-[#181616] dark:fill-gray-100"
      d="M36 8L8 36L12 40L40 12L36 8Z"
    />
  </svg>
)
Empty.displayName = 'Empty'
Empty.defaultProps = {
  size: 24,
}

export default Empty
